var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
var SvgNotificationIcon = function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    width: 16,
    height: 16,
    fill: props.fillLine,
    rx: 4
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M10.02 4.4c-.497 0-.977.124-1.406.358q.233.238.415.517c.307-.154.645-.235.991-.235 1.177 0 2.098.865 2.098 1.968 0 1.329-.927 2.178-3.401 4.45l-.156.143a2.6 2.6 0 0 1-.396.3.79.79 0 0 1-.635.084c-.376-.113-.672-.212-.742-.235-.189-.338-.255-1.616-.266-2.132C7.85 9.385 8.81 8.304 8.81 7.033q0-.599-.28-1.142l-.012-.022q-.005-.007-.008-.017a2 2 0 0 0-.082-.14h.001l-.02-.03a2.9 2.9 0 0 0-.825-.822 2.9 2.9 0 0 0-1.579-.46h-.026c-1.559 0-2.779 1.145-2.779 2.607 0 1.51 1.11 2.64 3.526 4.806l.006.005.772.689.206.184c.079.07.182.109.29.109.11 0 .213-.039.291-.11l.206-.183c2.955-2.634 4.303-3.836 4.303-5.5 0-1.462-1.22-2.607-2.779-2.607M6.058 9.07a.41.41 0 0 0-.208.316l-.008.1c-.003.045-.006.107.005.33l.032.325c-1.297-1.237-2-2.113-2-3.134v-.006h.003l.001-.049c.046-1.065.97-1.905 2.106-1.912a2.27 2.27 0 0 1 1.705.791c.283.35.433.766.433 1.201 0 1.01-.807 1.86-1.876 1.977a.5.5 0 0 0-.193.06"
  })));
};
export default SvgNotificationIcon;